/**
 * ComingSoonPlaceholder - Placeholder for future query UI
 *
 * Displays centered "Coming Soon" message in left pane of split view.
 * Pattern based on EmptyState from QueryWriter.tsx lines 265-279.
 */
export const ComingSoonPlaceholder = () => {
  return (
    <div
      className="flex h-full items-center justify-center"
      data-testid="coming-soon-placeholder"
    >
      <p className="text-chariot-text-secondary text-sm">Coming Soon</p>
    </div>
  );
};
